import {ODocument} from "./odocument";
import {ORole} from "./orole";

export class OUser extends ODocument {

  name: string;
  password: string;
  status = "ACTIVE";
  roles: ORole[] = [];

  constructor() {
    super("OUser");
  }

}

